import React from 'react'
import './Header.css'

type TabType = 'dashboard' | 'memories' | 'goals' | 'emotions' | 'recommendations' | 'pet' | 'statistics' | 'settings'

interface HeaderProps {
  activeTab: TabType
  onTabChange: (tab: TabType) => void
}

const Header: React.FC<HeaderProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'dashboard' as TabType, label: '首页', icon: '🏠' },
    { id: 'memories' as TabType, label: '回忆相册', icon: '📸' },
    { id: 'goals' as TabType, label: '目标规划', icon: '🎯' },
    { id: 'emotions' as TabType, label: '情感记录', icon: '💕' },
    { id: 'recommendations' as TabType, label: '智能推荐', icon: '🤖' },
    { id: 'pet' as TabType, label: '小灵宠', icon: '🐾' },
    { id: 'statistics' as TabType, label: '数据统计', icon: '📊' },
    { id: 'settings' as TabType, label: '设置', icon: '⚙️' }
  ]

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <span className="logo-icon">💖</span>
          <h1 className="logo-text">甜蜜记录</h1>
        </div>
        
        <nav className="nav">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => onTabChange(tab.id)}
            >
              <span className="nav-icon">{tab.icon}</span>
              <span className="nav-label">{tab.label}</span>
            </button>
          ))}
        </nav>
        
        <div className="user-info">
          <div className="couple-avatars">
            <div className="avatar avatar-1">👨</div>
            <div className="avatar avatar-2">👩</div>
          </div>
          <div className="love-days">
            <span className="days-count">1234</span>
            <span className="days-label">天</span>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header